export const RESCHEDULE_APPROVER_LABELS = {
  admin: 'Admin',
  recruiter: 'Recruiter',
  client: 'Client'
};

export function approverKeyForRole(role) {
  if (role === 'admin' || role === 'recruiter' || role === 'client') return role;
  return null;
}

export function canActOnRescheduleApproval(userRole, summary) {
  const key = approverKeyForRole(userRole);
  if (!key || !summary?.approvals) return false;
  return summary.approvals[key]?.status === 'pending';
}

export function approvalStatusLabel(status) {
  if (status === 'approved') return 'Approved';
  if (status === 'rejected') return 'Rejected';
  return 'Pending';
}

export const APPROVAL_STATUS_STYLES = {
  approved:
    "bg-[hsl(var(--ds-success)/0.12)] text-[hsl(var(--ds-success))] border border-[hsl(var(--ds-success)/0.25)]",
  rejected:
    "bg-[hsl(var(--ds-danger)/0.12)] text-[hsl(var(--ds-danger))] border border-[hsl(var(--ds-danger)/0.25)]",
  pending:
    "bg-[hsl(var(--ds-warning)/0.15)] text-[hsl(var(--ds-warning-fg))] border border-[hsl(var(--ds-warning)/0.35)]",
};
